import {useState, useEffect} from 'react'
// WP-T5: source the members-screen filter chips from the taxonomy catalog (with a legacy
// /members/member-types/ fallback until the taxonomy backend is deployed).
import {getCategoryChipsWithFallback} from '../../services/memberCategoriesService'

export const useCategoriesMembers = () => {
  const [data, setData] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    let isMounted = true
    const fetch = async () => {
      try {
        const data = await getCategoryChipsWithFallback()
        if (isMounted) {
          setData(data)
        }
      } catch (err) {
        if (isMounted) {
          setError(err as Error)
        }
      } finally {
        if (isMounted) {
          setLoading(false)
        }
      }
    }
    fetch()
    return () => {
      isMounted = false
    }
  }, [])

  return {data, loading, error}
}
